// KundenverbindungPopup.tsx — Zelle der „Kundenverbindungen"-Spalte: ein Chip
// mit dem Namen der Kundenverbindung des Kontakts (+ „·N"-Mitgliederzähler).
// Klick öffnet ein portaliertes Popover (RdPopover) mit GENAU DIESER
// Kundenverbindung und allen Mitgliedern (lazy via GET /contactgroup/:id/contacts);
// Klick auf einen Kontakt → ContactDetails. READ-ONLY — das Bearbeiten von Name
// und Mitgliedern erfolgt im Popup der Dashboard-Karte „Kundenverbindungen"
// (KundenverbindungDialog).

import { useState } from "react";
import { useNavigate } from "react-router";
import { RdPopover } from "./table/RdPopover";
import { apiFetch } from "../../utils/apiFetch";
import { contactTypeLabel } from "../../utils/contactTypeLabel";

type Member = { id: number; name: string; typ: string };

export function KundenverbindungCell({ group, count }: { group: { id: number; name: string }; count?: number }) {
  const navigate = useNavigate();
  const [members, setMembers] = useState<Member[] | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const load = () => {
    if (members !== undefined || loading) return;
    setLoading(true);
    setError(false);
    apiFetch<Member[]>(`contactgroup/${group.id}/contacts`)
      .then(({ data }) => setMembers(Array.isArray(data) ? data : []))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  };

  return (
    <span className="kvc-cell" onClick={(e) => e.stopPropagation()}>
      <RdPopover
        align="start"
        width={360}
        trigger={({ open, toggle, ref }) => (
          <button
            ref={ref}
            type="button"
            className={"kvc-chip" + (open ? " on" : "")}
            title={group.name}
            onClick={(e) => {
              e.stopPropagation();
              if (!open) load();
              toggle();
            }}
          >
            <span className="kvc-name">{group.name}</span>
            {count != null && <span className="kvc-count">·{count}</span>}
          </button>
        )}
      >
        {() => (
          <div className="rd-pop-body kvc-pop" onClick={(e) => e.stopPropagation()}>
            <div className="rd-pop-grouptitle">{group.name}</div>
            <div className="kvc-pop-list">
              {loading || members === undefined ? (
                <div className="kvc-msg">Lädt …</div>
              ) : error ? (
                <div className="kvc-msg">Mitglieder konnten nicht geladen werden.</div>
              ) : members.length > 0 ? (
                members.map((m) => (
                  <button
                    type="button"
                    key={m.id}
                    className="kvc-member"
                    onClick={() => navigate(`/kontakte/edit/${m.id}`)}
                  >
                    <span className="kvc-member-name">{m.name}</span>
                    <span className="kvc-member-typ">{contactTypeLabel(m.typ)}</span>
                  </button>
                ))
              ) : (
                <div className="kvc-msg">Keine Kontakte in dieser Kundenverbindung.</div>
              )}
            </div>
          </div>
        )}
      </RdPopover>
    </span>
  );
}
